import React from 'react'
import NewPasswordForm from 'components/forgot-password/NewPasswordForm'
import OTPForm from 'components/delete-account/DeleteAccount'
import DeleteAccountForm from 'components/delete-account/DeleteAccountForm'
import VerifyOtp from 'components/verify-otp/VerifyOtp'
import { history, ROUTING_STORE } from 'store'
import { Switch, Route, Router as ReactRouter } from 'react-router'
import PrivateRoute from './PrivateRoute'
import AdminRoute from './AdminRoute'
import { inject, observer } from 'mobx-react'
import { RouterStore } from 'mobx-react-router'
import {
  LoginPage,
  DashboardPage,
  ProjectsPage,
  CreateProjectPage,
  AdminDashboardPage,
  SsoAllowedEmailsPage,
  InviteUserPage,
  SignUpPage,
  PersonsPage,
  AddPersonPage,
  BrandsPage,
  AddBrandPage,
  EditPersonPage,
  ProjectEditPage,
  BrandEditPage,
  ProductsPage,
  AddProductPage,
  AgreementsPage,
  AddAgreementPage,
  AgreementEditPage,
  EditProductPage,
  EditorPage,
  ShotWizardPage,
  TimelineTagsPage,
  StatisticsMainPage,
  ActionHistoryPage,
  ViewersPage,
  ViewerInfoPage,
  UsersTablePage,
  InviteUserPageDeprecated,
  MyProfilePage,
  UserProfilePage,
  AgreementViewPage
} from 'pages'
import { Header, SideMenu, LoadingSpinner, ModalDialog } from 'components'
import { isShotWizardPageOpened, isTimelineTagsPageOpened } from 'utilities'
import { DialogPopupHandler } from 'components/shared'
import { notAllowedUserRolesBySection } from 'config/not-allowed-user-roles-by-section'
import { MainContainer } from '@touche-lts/panel-ui/dist'
import { ShopifyAddAgreementPage } from '../pages/agreements/ShopifyAgreementPage/ShopifyAddAgreementPage'
import { AllowedSsoEmailsPage } from '../pages/allowed-sso-emails-table/allowed-sso-emails-table'

interface Props {
  [ROUTING_STORE]?: RouterStore
}

const Router = (props: Props) => {
  const { pathname } = props[ROUTING_STORE]!.location
  const visibleHeader = pathname !== '/login' && !pathname.startsWith('/signup') && pathname !== '/reset-password' && pathname !== '/delete-account' && pathname !== '/deleteform' && pathname !== '/verify-otp' && pathname !== '/shopify/agreements/add'
  const visibleSideMenu =
    visibleHeader &&
    !isShotWizardPageOpened(pathname) &&
    !isTimelineTagsPageOpened(pathname)

  return (
    <ReactRouter history={history}>
      {visibleHeader && <Header />}

      <MainContainer>
        {visibleSideMenu && <SideMenu />}

        <div
          style={{
            flex: 1,
            minWidth: 0,
            display: 'flex',
            flexDirection: 'column'
          }}
        >
        <Switch>
          {/* Public routes */}
          <Route path='/reset-password' component={NewPasswordForm}/>
          <Route path='/delete-account' component={OTPForm} />
          <Route path='/verify-otp' component={VerifyOtp} />
          <Route path='/deleteform' component={DeleteAccountForm} />
          <Route path='/login' component={LoginPage} />
          <Route path='/signup/:code' component={SignUpPage} />
          <Route
            path='/shopify/agreements/add'
            exact
            component={ShopifyAddAgreementPage}
          />

          {/* Private routes */}
          <PrivateRoute
            path='/'
            exact
            component={DashboardPage}
            notAllowedUserRoleNames={notAllowedUserRolesBySection.dashboard}
          />
          <PrivateRoute
            path='/dashboard'
            component={DashboardPage}
            notAllowedUserRoleNames={notAllowedUserRolesBySection.dashboard}
          />

          <PrivateRoute
            path='/projects'
            exact
            component={ProjectsPage}
            notAllowedUserRoleNames={notAllowedUserRolesBySection.projects}
          />
          <PrivateRoute
            path='/projects/create/'
            exact
            component={CreateProjectPage}
            notAllowedUserRoleNames={notAllowedUserRolesBySection.projects}
          />
          <PrivateRoute
            path='/projects/create/:parentId'
            exact
            component={CreateProjectPage}
            notAllowedUserRoleNames={notAllowedUserRolesBySection.projects}
          />
          <PrivateRoute
            path='/projects/:projectType'
            exact
            component={ProjectsPage}
            notAllowedUserRoleNames={notAllowedUserRolesBySection.projects}
          />
          <PrivateRoute
            path='/projects/edit/:id'
            exact
            component={ProjectEditPage}
            notAllowedUserRoleNames={notAllowedUserRolesBySection.projects}
          />

          <PrivateRoute
            path='/persons'
            exact
            component={PersonsPage}
            notAllowedUserRoleNames={notAllowedUserRolesBySection.people}
          />
          <PrivateRoute
            path='/persons/add'
            exact
            component={AddPersonPage}
            notAllowedUserRoleNames={notAllowedUserRolesBySection.peopleCreate}
          />
          <PrivateRoute
            path='/persons/:id'
            exact
            component={EditPersonPage}
            notAllowedUserRoleNames={notAllowedUserRolesBySection.people}
          />

          <PrivateRoute
            path='/brands'
            exact
            component={BrandsPage}
            notAllowedUserRoleNames={notAllowedUserRolesBySection.brands}
          />
          <PrivateRoute
            path='/brands/add'
            exact
            component={AddBrandPage}
            notAllowedUserRoleNames={notAllowedUserRolesBySection.brands}
          />
          <PrivateRoute
            path='/brands/edit/:id'
            exact
            component={BrandEditPage}
            notAllowedUserRoleNames={notAllowedUserRolesBySection.brands}
          />

          <PrivateRoute
            path='/products'
            exact
            component={ProductsPage}
            notAllowedUserRoleNames={notAllowedUserRolesBySection.products}
          />
          <PrivateRoute
            path='/products/:id'
            exact
            component={ProductsPage}
            notAllowedUserRoleNames={notAllowedUserRolesBySection.products}
          />
          <PrivateRoute
            path='/products/add'
            exact
            component={AddProductPage}
            notAllowedUserRoleNames={notAllowedUserRolesBySection.products}
          />
          <PrivateRoute
            path='/products/edit/:id'
            exact
            component={EditProductPage}
            notAllowedUserRoleNames={notAllowedUserRolesBySection.products}
          />

          <PrivateRoute
            path='/agreements'
            exact
            component={AgreementsPage}
            notAllowedUserRoleNames={notAllowedUserRolesBySection.agreements}
          />
          <PrivateRoute
            path='/agreements/add'
            exact
            component={AddAgreementPage}
            notAllowedUserRoleNames={notAllowedUserRolesBySection.agreements}
          />
          <PrivateRoute
            path='/agreements/:id'
            exact
            component={AgreementViewPage}
            notAllowedUserRoleNames={notAllowedUserRolesBySection.agreements}
          />
          <PrivateRoute
            path='/agreements/edit/:id'
            exact
            component={AgreementEditPage}
            notAllowedUserRoleNames={notAllowedUserRolesBySection.agreements}
          />

          <PrivateRoute
            path='/editor/:projectId/shots/:videoEntityId'
            exact
            component={ShotWizardPage}
            notAllowedUserRoleNames={notAllowedUserRolesBySection.projects}
          />
          <PrivateRoute
            path='/editor/:projectId/timeline-tags/:videoEntityId'
            exact
            component={TimelineTagsPage}
            notAllowedUserRoleNames={notAllowedUserRolesBySection.projects}
          />
          <PrivateRoute
            path='/editor/:id'
            exact
            component={EditorPage}
            notAllowedUserRoleNames={notAllowedUserRolesBySection.projects}
          />

          <PrivateRoute
            path='/statistics'
            exact
            component={StatisticsMainPage}
            notAllowedUserRoleNames={notAllowedUserRolesBySection.statistics}
          />
          <PrivateRoute
            path='/action-history'
            exact
            component={ActionHistoryPage}
            notAllowedUserRoleNames={notAllowedUserRolesBySection.actionHistory}
          />

          <PrivateRoute
            path='/viewers'
            exact
            component={ViewersPage}
            notAllowedUserRoleNames={notAllowedUserRolesBySection.viewers}
          />
          <PrivateRoute
            path='/viewers/:id'
            exact
            component={ViewerInfoPage}
            notAllowedUserRoleNames={notAllowedUserRolesBySection.viewers}
          />

          <PrivateRoute
            path='/user-management'
            exact
            component={UsersTablePage}
            notAllowedUserRoleNames={
              notAllowedUserRolesBySection.userManagement
            }
          />
          <PrivateRoute
            path='/user-management/invite'
            exact
            component={InviteUserPage}
            notAllowedUserRoleNames={
              notAllowedUserRolesBySection.userManagement
            }
          />
          <PrivateRoute
            path='/user-management/my-profile'
            exact
            component={MyProfilePage}
          />
          <PrivateRoute
            path='/user-management/:userId'
            exact
            component={UserProfilePage}
            notAllowedUserRoleNames={
              notAllowedUserRolesBySection.userManagement
            }
          />

          <PrivateRoute exact path={"/allowed-email"} component={AllowedSsoEmailsPage} />
          <PrivateRoute
            exact
            path="/sso-allowed-emails"
            component={AllowedSsoEmailsPage}
            notAllowedUserRoleNames={notAllowedUserRolesBySection.allowedEmail}
          />

          {/* Admin routes */}
          <AdminRoute
            path='/administration'
            exact
            component={AdminDashboardPage}
          />
          <AdminRoute
            path='/administration/invite-user'
            component={InviteUserPageDeprecated}
          />
          <AdminRoute
            path='/administration/sso-allowed-emails'
            exact
            component={SsoAllowedEmailsPage}
          />

          {/* Not found routes */}
          <PrivateRoute path='/*' component={DashboardPage} /> {/* Redirect to Dashboard Page */}
        </Switch>
        </div>
      </MainContainer>

      <LoadingSpinner />

      <ModalDialog />

      <DialogPopupHandler />
    </ReactRouter>
  )
}

export default inject(ROUTING_STORE)(observer(Router))
